import { useQuery } from "@apollo/client";
import Button from "components/Button";
import Errors from "components/Errors";
import Page from "components/Page";
import Spinner from "components/Spinner";
import { useSearchParams } from "react-router-dom";
import { FETCH_SUPPLIER_STOCK_UPDATE_REQUESTS } from "./graphql";
import SupplierStockSubmitHistoryItem from "./SupplierStockSubmitHistoryItem";

const PAGE_SIZE = 20;

const SubmitHistoryPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const offset = parseInt(searchParams.get("offset") || "0");
  const q = searchParams.get("q");

  const { loading, error, data } = useQuery(
    FETCH_SUPPLIER_STOCK_UPDATE_REQUESTS,
    {
      variables: {
        limit: PAGE_SIZE,
        offset,
      },
    },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const total = data.spSupplierStockUpdateRequests.total;
  const res = data.spSupplierStockUpdateRequests.results;
  const products = data.supplierStockProducts;
  const productsById = products.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});

  return (
    <Page title="History 提交历史" backTo="./..">
      <div className="p-8 flex-1 flex flex-col overflow-auto">
        {res.length === 0 ? (
          <div className=" opacity-70">
            No submit history yet. 暂无提交记录。
          </div>
        ) : (
          <div>
            <div className="space-y-6">
              {res.map((i) => (
                <SupplierStockSubmitHistoryItem
                  key={i.id}
                  item={i}
                  productsById={productsById}
                />
              ))}
            </div>

            <div className="flex justify-end items-center space-x-2 px-4 py-3 mt-6">
              {offset > 0 ? (
                <Button
                  prev
                  onClick={() =>
                    setSearchParams({
                      offset: String(offset - PAGE_SIZE),
                      q: q || "",
                    })
                  }
                />
              ) : null}
              <div>
                {total === 0 ? 0 : offset + 1} - {total}
              </div>
              {total > offset + PAGE_SIZE ? (
                <Button
                  next
                  onClick={() =>
                    setSearchParams({
                      offset: String(offset + PAGE_SIZE),
                      q: q || "",
                    })
                  }
                />
              ) : null}
            </div>
          </div>
        )}
      </div>
    </Page>
  );
};

export default SubmitHistoryPage;
